// src/pages/components/FooterPlayer.js
import React, { useState, useEffect, useRef } from "react";
import { Howl } from "howler";
import {
  Box,
  Container,
  Typography,
  IconButton,
} from "@mui/material";
import { PlayArrow, Pause, SkipNext, RepeatOne, Repeat } from "@mui/icons-material";

const soundtrack = [
  { src: "/audio/INDALAH.mp3", title: "Indalah" },
  { src: "/audio/Track2.mp3", title: "Track 2" },
  { src: "/audio/Track3.mp3", title: "Track 3" },
];

const FooterPlayer = () => {
  const [currentTrack, setCurrentTrack] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [player, setPlayer] = useState(null);
  const [loop, setLoop] = useState(false);
  const [timecode, setTimecode] = useState("0:00");

  const intervalRef = useRef(null);

  useEffect(() => {
    if (player) player.unload();

    const newPlayer = new Howl({
      src: [soundtrack[currentTrack].src],
      html5: true,
      loop: loop,
      onend: () => {
        if (!loop) nextTrack();
      },
    });

    setPlayer(newPlayer);

    if (isPlaying) newPlayer.play();

    return () => {
      newPlayer.unload();
      clearInterval(intervalRef.current);
    };
  }, [currentTrack, loop]);

  const togglePlay = () => {
    if (!player) return;

    if (isPlaying) {
      player.pause();
      setIsPlaying(false);
      clearInterval(intervalRef.current);
    } else {
      player.play();
      setIsPlaying(true);
      startTimer();
    }
  };

  const stopTrack = () => {
    if (!player) return;
    player.stop();
    setIsPlaying(false);
    clearInterval(intervalRef.current);
    setTimecode("0:00");
  };

  const nextTrack = () => {
    stopTrack();
    setCurrentTrack((prev) => (prev + 1) % soundtrack.length);
    setIsPlaying(true);
  };

  const startTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      if (player) {
        const seek = player.seek() || 0;
        setTimecode(formatTime(seek));
      }
    }, 500);
  };

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60) || 0;
    const seconds = Math.floor(secs % 60) || 0;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const toggleLoop = () => {
    setLoop((prev) => !prev);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "#111",
        color: "white",
        py: 1,
        zIndex: 1200,
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
        }}
      >
        {/* Banner */}
        <img
          src="/images/wsl-logo-trans.png"
          alt="Akwerius Banner"
          style={{
            height: "40px",
            borderRadius: "4px",
            objectFit: "contain",
          }}
        />

        {/* Controls - bigger on mobile */}
        <IconButton
          onClick={togglePlay}
          sx={{ color: "white", fontSize: { xs: "2rem", md: "1.5rem" } }}
        >
          {isPlaying ? <Pause fontSize="inherit" /> : <PlayArrow fontSize="inherit" />}
        </IconButton>
        <IconButton
          onClick={nextTrack}
          sx={{ color: "white", fontSize: { xs: "2rem", md: "1.5rem" } }}
        >
          <SkipNext fontSize="inherit" />
        </IconButton>
        <IconButton
          onClick={toggleLoop}
          sx={{ color: "white", fontSize: { xs: "2rem", md: "1.5rem" } }}
        >
          {loop ? <Repeat color="primary" fontSize="inherit" /> : <RepeatOne fontSize="inherit" />}
        </IconButton>

        {/* Title + time */}
        <Typography
          variant="body1"
          fontWeight="bold"
          noWrap
          sx={{ fontSize: { xs: "1rem", md: "0.875rem" } }}
        >
          {soundtrack[currentTrack].title} — {timecode}
        </Typography>

        {/* Waveform: hidden on mobile */}
        <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }}>
          <img
            src="/images/indalah-waveform.png"
            alt="Indalah Waveform"
            style={{
              height: "40px",
              width: "100%",
              borderRadius: "4px",
              objectFit: "cover",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default FooterPlayer;




// // src/pages/components/FooterPlayer.js
// import React, { useState, useEffect } from "react";
// import { Howl } from "howler";
// import "./Footer.css"; // optional CSS for styling

// // List of tracks
// const soundtrack = [
//   { src: "/audio/INDALAH.mp3", title: "Indalah" },
//   { src: "/audio/Track2.mp3", title: "Track 2" },
//   { src: "/audio/Track3.mp3", title: "Track 3" },
// ];

// const FooterPlayer = () => {
//   const [currentTrack, setCurrentTrack] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [player, setPlayer] = useState(null);

//   // Initialize Howl player when currentTrack changes
//   useEffect(() => {
//     if (player) {
//       player.unload(); // unload previous track
//     }

//     const newPlayer = new Howl({
//       src: [soundtrack[currentTrack].src],
//       html5: true, // ensures large audio files stream properly
//       onend: () => nextTrack(), // automatically go to next track
//     });

//     setPlayer(newPlayer);

//     // Auto play if we were already playing
//     if (isPlaying) {
//       newPlayer.play();
//     }

//     return () => {
//       newPlayer.unload();
//     };
//   }, [currentTrack]);

//   const togglePlay = () => {
//     if (!player) return;

//     if (isPlaying) {
//       player.pause();
//       setIsPlaying(false);
//     } else {
//       player.play();
//       setIsPlaying(true);
//     }
//   };

//   const stopTrack = () => {
//     if (!player) return;
//     player.stop();
//     setIsPlaying(false);
//   };

//   const nextTrack = () => {
//     stopTrack();
//     setCurrentTrack((prev) => (prev + 1) % soundtrack.length);
//     setIsPlaying(true);
//   };

//   return (
//     <footer className="footer-player">
//       <div className="player-controls">
//         <button onClick={togglePlay} className="btn btn-primary">
//           {isPlaying ? "Pause" : "Play"}
//         </button>
//         <button onClick={nextTrack} className="btn btn-info">
//           Next
//         </button>
//       </div>
//       <div className="now-playing">
//         Now Playing: <strong>{soundtrack[currentTrack].title}</strong>
//       </div>
//     </footer>
//   );
// };

// export default FooterPlayer;
